import {SHOW_MODAL, HIDE_MODAL} from '../actions/types';

const initialState = {
    modals: []
}

export function modal(state = initialState, action = {}) {
    switch (action.type) {
        case SHOW_MODAL:
            let newModal = {modalType: action.modalType};
            return Object.assign({}, state, {modals: state.modals.concat(newModal)});
        case HIDE_MODAL:
            let newModals = state.modals.filter(m => m.modalType !== action.modalType);
            return Object.assign({}, state, {modals: newModals});
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/modal.js